import { useCallback } from 'react';
import {
  useGetUserMeQuery,
  useUpdateUserMutation,
} from '../../impl/blfApi/endpoints/users';
import { defaultUserSettings } from './useSettings';

export const useInitialOnboardingComplete = (): {
  initialOnboardingComplete: boolean;
  setInitialOnboardingComplete: (onboardingComplete: boolean) => void;
} => {
  const { data: user } = useGetUserMeQuery();

  const [updateUser] = useUpdateUserMutation();

  const setOnboardingComplete = useCallback(
    async (onboardingComplete: boolean) => {
      if (user?.id) {
        try {
          await updateUser({
            id: user.id,
            settings: {
              ...(user?.settings ?? defaultUserSettings),
              onboardingComplete,
            },
          }).unwrap();
        } catch (error) {
          console.error(error);
          throw new Error('Failed to update user settings');
        }
      }
    },
    [user?.id, user?.settings, updateUser]
  );

  return {
    initialOnboardingComplete: user?.settings?.onboardingComplete ?? true,
    setInitialOnboardingComplete: setOnboardingComplete,
  };
};
